import React, { Component } from 'react'
import { withCookies } from 'react-cookie'
import { connect } from 'react-redux'
import * as locationHelpers from '../../../../../helpers/locationHelpers'
import { updateNotification } from '../../../../../actions/common/site_notifications'
import LocationInput from './LocationInput'
class LocationPreferences extends Component {
  state = {
    locations: {
      current: {},
      relocation: []
    },
    messages: {
      current: {
        text: undefined
      },
      relocation: {
        text: undefined
      }
    },
    validation: {
      current: undefined,
      relocation: undefined
    },
    disabled: true
  }

  async componentDidMount() {
    let memberLocations
    try {
      memberLocations = await locationHelpers.getMemberLocations()
    } catch (error) {
      console.error('Unable to fetch member locations')
    }
    this.setExistingMemberLocations(memberLocations)
  }

  setExistingMemberLocations = (memberLocations) => {
    if (memberLocations && memberLocations.success && memberLocations.data && memberLocations.data.hasOwnProperty('livingLocation') && memberLocations.data.hasOwnProperty('willingToWorkLocations')) {
      this.setState({
        ...this.state,
        locations: {
          current: this.convertLivingLocationToCurrent(memberLocations.data.livingLocation),
          relocation: this.convertWillingToWorkToRelocation(memberLocations.data.willingToWorkLocations)
        },
        validation: {
          current: Object.keys(memberLocations.data.livingLocation).length > 0 ? true : undefined,
          relocation: memberLocations.data.willingToWorkLocations.length > 0 ? true : undefined
        }
      })
    }
  }

  convertLivingLocationToCurrent = (livingLocation) => {
    return (livingLocation.hasOwnProperty('formatted_name')) ? {
      label: livingLocation.formatted_name,
      value: livingLocation.location_id
    } : {}
  }

  convertWillingToWorkToRelocation = (willingToWorkLocations) => {
    return (Array.isArray(willingToWorkLocations)) ?
      willingToWorkLocations.map(location => {
        return {
          label: location.formatted_name,
          value: location.location_id
        }
      })
      : []
  }

  handleFocus = () => {

    const messages = {
      ...this.state.messages,
      current: {
        text: ''
      },
      relocation: {
        text: '' 
      }
    }

    this.setState({
      messages
    })

  }

  handleLocationChange = (value, fieldName) => {
    let locations = {
      ...this.state.locations,
    }
    locations[fieldName] = value

    this.setState({ locations }, () => this.handleValidation())
  }

  handleValidation = () => {

    let validation = {
      ...this.state.validation,
      current: this.state.locations.current.hasOwnProperty('value') ? true : false,
      relocation: this.state.locations.relocation && this.state.locations.relocation.length > 0 ? true : false
    }

    const disabled = validation.current && validation.relocation ? false : true;

    this.setState({ validation, disabled })
  }

  setRelocationResponseMessage = (response) => {
    const status = response.status
    const isError = response.error ? true : false
    const result = response.response

    const text = (status === 200)
      ? isError
        ? `Error: We were unable to link ${result.map(err => err.label).join(' and ')} to your account. Please try again.`
        : 'Successfully updated where you are willing to work.'
      : 'Error: We were unable to update your location details. Please try again.'

    const messages = {
      ...this.state.messages,
      relocation: {
        text 
      }
    }

    this.setState({
      messages
    })
  }

  setCurrentResponseMessage = (isSuccess) => {
    const messages = {
      ...this.state.messages,
      current: {
        text: (isSuccess) ? 'Successfully updated your current location.' : 'Error: There has been an error setting your current location. Please try again.'
      }
    }
    this.setState({
      messages
    })
  }

  handleSubmit = (e) => {

    e.preventDefault()
    const { locations, validation } = this.state

    const data = {
      personId: localStorage.person_id,
      notificationId: 2,
      completed: 1
    }

    this.handleValidation();

    this.props.updateNotification(data)
    if (validation.current && validation.relocation) {
      Promise.all([
        locationHelpers.postMemberLivingLocation(locations.current.value),
        locationHelpers.postMemberWillingToWorkLocations(locations.relocation)
      ]).then((responses) => {
        this.setCurrentResponseMessage(responses[0].success)
        this.setRelocationResponseMessage(responses[1])
      })
    }
  }

  render() {
    const { messages, validation, disabled } = this.state
    return (
      <div className="row form-location-preferences">
        <div className="col-xs-12 col-centered">
          <div onFocus={ this.handleFocus }>
            <legend>Location you currently live in</legend>
            {validation.current === false && <label className="location-form-label">Current Location is required*</label>}
            <LocationInput
              name="current"
              handleChange={this.handleLocationChange}
              values={this.state.locations.current}
            />
            {messages.current.text && <label className="success-message">{messages.current.text}</label>}
          </div>

          <div onFocus={ this.handleFocus }><br />
            <legend>Locations you are willing to work in</legend>
            {validation.relocation === false && <label className="location-form-label">Willing to work locations are required*</label>}
            <LocationInput
              name="relocation"
              isMulti
              handleChange={this.handleLocationChange}
              values={this.state.locations.relocation}
            />
            {messages.relocation.text && <label className="success-message">{messages.relocation.text}</label>}
          </div>

        </div>
        <ul className="buttons-center padding-top">
          <li>
            <button className="btn btn-primary" type="submit" disabled={disabled} onClick={this.handleSubmit}>
              <span className="label">Save</span>
              <span className="icon"><i className="fa fa-pencil" /></span>
            </button>
          </li>
        </ul>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  updateNotification: (data) => dispatch(updateNotification(data)),
});

export default withCookies(connect(null, mapDispatchToProps)(LocationPreferences));


// WEBPACK FOOTER //
// src/client/components/site/features/account/location/LocationPreferences.js